module.exports = __webpack_public_path__ + "static/media/penalty-miss.4d662e0a.svg";